import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  title: {
    textAlign: 'center',
    mb: '4px'
  } satisfies SxProps<Theme>,
  subtitle: {
    textAlign: 'center',
    mb: '24px'
  } satisfies SxProps<Theme>,
  providerList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  } satisfies SxProps<Theme>,
  providerButton: {
    textTransform: 'none',
    justifyContent: 'center',
    color: 'text.primary',
    backgroundColor: 'var(--grey-50)',
    border: '1px solid var(--border)',
    borderRadius: '6px',
    minHeight: '58px',
    fontWeight: 600,
    '&:hover': { backgroundColor: 'var(--grey-100)', border: '1px solid var(--border)' }
  } satisfies SxProps<Theme>,
  micredsHeading: {
    textAlign: 'center',
    mb: '12px'
  } satisfies SxProps<Theme>,
  micredsButton: {
    textTransform: 'none',
    minHeight: '48px',
    borderRadius: '4px'
  } satisfies SxProps<Theme>,
  footnote: {
    display: 'block',
    mt: '20px',
    textAlign: 'center'
  } satisfies SxProps<Theme>
}
